export const HOST_PAYMENTS_PAYOUT_TERMS_VERSION = 1;
export const HOST_PAYMENTS_PAYOUT_TERMS_PATH = '/website/host-payments-payout-terms';
